import React, { useState } from 'react';
// import Login from './Login';
// import Registration from './Registration';
// import RegistrationStep2 from './RegistrationStep2';
// import ForgotPassword from './ForgotPassword';
// import ResetPassword from './ResetPassword';
import { useUser } from '../../auth/UseUser';
import { ReactComponent as UpstriveLogo } from '../../assets/svg/UpstriveLogo.svg';
import { ReactComponent as LoginImage } from '../../assets/svg/LoginImage.svg';
import Login from './Login';
import Registration from './Registration';

function LoginScreen() {
	return (
		<div className='w-full bg-redError flex flex-row items-center h-[100vh] '>
			<div className='bg-white w-full  h-full overflow-auto orange-tiny-scroll md:orange-small-scroll'>
				<div className='w-full pt-8 h-full flex'>
					<Login />
				</div>
			</div>
		</div>
	);
}

export default LoginScreen;
